__webpack_require__.p = "https://cdn.commanderspellbook.com/_next/";